import { useEffect } from 'react';
import { getGoogleFontUrl } from '../lib/themeUtils';

export function useThemeFont(fontFamily: string | undefined): void {
  useEffect(() => {
    if (!fontFamily) return;

    const url = getGoogleFontUrl(fontFamily);
    if (!url) return;

    const existingLink = document.querySelector(`link[href="${url}"]`);
    if (existingLink) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.dataset.themeFont = fontFamily;
    document.head.appendChild(link);

    return () => {
      const linkEl = document.querySelector(`link[data-theme-font="${fontFamily}"]`);
      if (linkEl) linkEl.remove();
    };
  }, [fontFamily]);
}
